module.exports = __webpack_public_path__ + "img/one_number.e6161341.png";